/** Block scientific-notation / sign keys that number inputs otherwise allow */
export const blockInvalidNumberKeys = (event) => {
    if (['e', 'E', '+', '-'].includes(event.key)) {
        event.preventDefault();
    }
};

export const sanitizeNumberInput = (value) =>
    String(value ?? '').replace(/[eE+\-]/g, '');

export const cloneFormItem = (item) => ({ ...(item || {}) });

export const trimTextOnBlur = (value, commit) => {
    if (typeof value !== 'string') return;
    const trimmedValue = value.trim();
    if (trimmedValue !== value) {
        commit(trimmedValue);
    }
};

/** Build a blank repeatable-form row (does not clone the previous item). */
export const createBlankFormItem = (fieldsMap = {}) => {
    const blank = { _clientKey: `new-${Date.now()}-${Math.random().toString(36).slice(2, 9)}` };
    Object.keys(fieldsMap || {}).forEach((key) => {
        const fieldDef = fieldsMap[key];
        if (fieldDef?.default !== undefined) {
            blank[key] = fieldDef.default;
        } else if (fieldDef?.type === 'checkbox') {
            blank[key] = false;
        } else if (fieldDef?.type === 'multi-select') {
            blank[key] = [];
        } else {
            blank[key] = '';
        }
    });
    return blank;
};

/** True when a progressive-reveal parent has a real value (arrays need length). */
export const hasRevealValue = (value) => {
    if (Array.isArray(value)) return value.length > 0;
    return value !== '' && value != null && value !== false;
};

export const createEmptyFormItems = (count, fieldsMap = {}) =>
    Array.from({ length: count }, () => createBlankFormItem(fieldsMap));

export const getFieldLabel = (field) => (field.required ? `${field.label} *` : field.label);

export const parsePhoneValue = (value, countryCodes = []) => {
    if (!value) return { dialCode: '', number: '' };
    const sorted = [...countryCodes].sort((a, b) => b.dialCode.length - a.dialCode.length);
    const match = sorted.find((c) => String(value).startsWith(c.dialCode));
    if (match) {
        return {
            dialCode: match.dialCode,
            number: String(value).slice(match.dialCode.length).replace(/^\s+/, ''),
        };
    }
    return { dialCode: '', number: String(value) };
};

export const matchCountryValue = (value, countries = []) => {
    if (!value) return null;
    const normalized = String(value).trim().toLowerCase().replace(/[\s_-]+/g, '');
    return countries.find((name) =>
        name.toLowerCase().replace(/[\s_-]+/g, '') === normalized
        || name.toLowerCase() === String(value).trim().toLowerCase()
    ) || null;
};
